import { useStores } from '../../../app/providers/withStore'
import { Typography, Menu, MenuItem } from '@mui/material'
import { usePathname } from '../../../shared/hooks/router'

const SortMenu = (props) => {
  const { handleClose, anchorEl } = props
  const pathname = usePathname()
  const { sortStore } = useStores()

  const clickSortHandler = (type) => {
    sortStore.setSort(type)
    handleClose()
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      sx={{ '& .MuiMenu-paper': { px: 1 } }}
    >
      <Typography align="center" sx={{ fontWeight: 700 }} variant="subtitle2">
        Упорядочивать по
      </Typography>
      <MenuItem
        onClick={() => {
          clickSortHandler('name') // Sort by property 'name'
        }}
      >
        <Typography align="center" variant="subtitle2">
          Имени
        </Typography>
      </MenuItem>
      <MenuItem
        onClick={() => {
          clickSortHandler('duration') // Sort by property 'duration'
        }}
      >
        <Typography align="center" variant="subtitle2">
          Длительности
        </Typography>
      </MenuItem>
      {pathname === '/bookings' ? (
        <MenuItem
          onClick={() => {
            clickSortHandler('start') // Sort by property 'start'
          }}
        >
          <Typography align="center" variant="subtitle2">
            Дате
          </Typography>
        </MenuItem>
      ) : (
        <MenuItem
          onClick={() => {
            clickSortHandler('price') // Sort by property 'price'
          }}
        >
          <Typography align="center" variant="subtitle2">
            Стоимости
          </Typography>
        </MenuItem>
      )}
    </Menu>
  )
}

export default SortMenu
